import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FreeToMessage from './StatusComponents/FreeToMessage';
import ExpressInterest from './StatusComponents/ExpressInterest';
import BecomeAPartner from './StatusComponents/BecomeAPartner';
import Disabled from './StatusComponents/Disabled';

const sectionSelector = {
  regular_seller             : {
    regular_seller             : props => <FreeToMessage {...props} />,
    regular_buyer              : props => <FreeToMessage {...props} />,
    implicitly_obfuscated_user : props => <ExpressInterest {...props} />,
    explicitly_obfuscated_user : props => <ExpressInterest {...props} expressThroughManager />,
    limited_access_seller      : props => <Disabled {...props} />,
    limited_access_buyer       : props => <Disabled {...props} />,
  },
  regular_buyer              : {
    regular_seller             : props => <FreeToMessage {...props} />,
    regular_buyer              : props => <FreeToMessage {...props} />,
    implicitly_obfuscated_user : props => <ExpressInterest {...props} />,
    explicitly_obfuscated_user : props => <ExpressInterest {...props} expressThroughManager />,
    limited_access_seller      : props => <ExpressInterest {...props} expressThroughManager />,
    limited_access_buyer       : props => <Disabled {...props} />,
  },
  implicitly_obfuscated_user : {
    regular_seller             : props => <ExpressInterest {...props} />,
    regular_buyer              : props => <ExpressInterest {...props} />,
    implicitly_obfuscated_user : props => <ExpressInterest {...props} />,
    explicitly_obfuscated_user : props => <ExpressInterest {...props} expressThroughManager />,
    limited_access_seller      : props => <Disabled {...props} />,
    limited_access_buyer       : props => <Disabled {...props} />,
  },
  explicitly_obfuscated_user : {
    regular_seller             : props => <ExpressInterest {...props} />,
    regular_buyer              : props => <ExpressInterest {...props} />,
    implicitly_obfuscated_user : props => <ExpressInterest {...props} />,
    explicitly_obfuscated_user : props => <ExpressInterest {...props} expressThroughManager />,
    limited_access_seller      : props => <Disabled {...props} />,
    limited_access_buyer       : props => <Disabled {...props} />,
  },
  limited_access_seller      : {
    regular_seller             : props => <BecomeAPartner {...props} />,
    regular_buyer              : props => <FreeToMessage {...props} />,
    implicitly_obfuscated_user : props => <BecomeAPartner {...props} />,
    explicitly_obfuscated_user : props => <BecomeAPartner {...props} />,
    limited_access_seller      : props => <Disabled {...props} />,
    limited_access_buyer       : props => <Disabled {...props} />,
  },
  limited_access_buyer       : {
    regular_seller             : props => <BecomeAPartner {...props} />,
    regular_buyer              : props => <BecomeAPartner {...props} />,
    implicitly_obfuscated_user : props => <BecomeAPartner {...props} />,
    explicitly_obfuscated_user : props => <BecomeAPartner {...props} />,
    limited_access_seller      : props => <Disabled {...props} />,
    limited_access_buyer       : props => <Disabled {...props} />,
  },
};

const getComponentType = props => {
  const currentUserType = props.getCurrentUser?.profile_type;
  const userType = props.user?.profile_type;

  // Defensive check to ensure both profile types exist
  if (!currentUserType || !userType) {
    console.warn('Missing profile types:', { currentUserType, userType });
    return <Disabled {...props} />;
  }

  // When marketplace_sellers_visible is on, growth users (regular_buyer)
  // viewing seller profiles (regular_seller) get the Express Interest
  // sidebar instead of FreeToMessage — enables the marketplace EOI flow.
  const companyFeatures = props.getCurrentUser?.company?.feature_types || props.getCurrentUser?.company?.features || [];
  const hasMarketplace = companyFeatures.includes('marketplace_sellers_visible');
  if (hasMarketplace && currentUserType === 'regular_buyer' && userType === 'regular_seller') {
    return <ExpressInterest {...props} />;
  }

  // Check if the combination exists in sectionSelector
  if (!sectionSelector[currentUserType] || !sectionSelector[currentUserType][userType]) {
    console.warn('Profile type combination not found in sectionSelector:', { currentUserType, userType });
    return <Disabled {...props} />;
  }

  return sectionSelector[currentUserType][userType](props);
};

const ProfileDrawerSideBar = props => {
  return <div>{getComponentType(props)}</div>;
};

ProfileDrawerSideBar.propTypes = {
  agentWordForCompany                  : PropTypes.string.isRequired,
  classes                              : PropTypes.object.isRequired,
  companyBusinessType                  : PropTypes.string.isRequired,
  companyHasNetworking                 : PropTypes.bool.isRequired,
  companyHasNewMessages                : PropTypes.bool.isRequired,
  currentCompanySellerWord             : PropTypes.string.isRequired,
  currentUserHasLimitedAccess          : PropTypes.bool,
  currentUserHasSellingTransitionGoals : PropTypes.bool,
  disableMessageBtn                    : PropTypes.bool,
  displaySocialButtons                 : PropTypes.bool,
  expressThroughManager                : PropTypes.bool,
  getCurrentUser                       : PropTypes.object.isRequired,
  hasInterestedUsers                   : PropTypes.bool.isRequired,
  loadBobCardList                      : PropTypes.func.isRequired,
  marketplaceOnly                      : PropTypes.bool,
  notes                                : PropTypes.array.isRequired,
  obfuscateView                        : PropTypes.bool.isRequired,
  scrollTo                             : PropTypes.func.isRequired,
  updateBobCards                       : PropTypes.func.isRequired,
  updateNotes                          : PropTypes.func.isRequired,
  updateProfile                        : PropTypes.func.isRequired,
  user                                 : PropTypes.object.isRequired,
};

ProfileDrawerSideBar.defaultProps = {
  expressThroughManager                : false,
  displaySocialButtons                 : false,
  marketplaceOnly                      : false,
  disableMessageBtn                    : false,
  currentUserHasSellingTransitionGoals : false,
  currentUserHasLimitedAccess          : false,
};

const styles = {
  margin : {
    margin : 5,
  },
};

export default withStyles(styles)(ProfileDrawerSideBar);
